(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dibbs-collection"]) return;
  try {
    
  (() => {
    const initializeDibbsCollections = () => {
      document.querySelectorAll('[data-db-collection-page]').forEach((root) => {
        const controls = root.querySelector('[data-db-collection-controls]');
        const grid = root.querySelector('[data-db-collection-grid]');
        if (!controls || !grid || controls.dataset.dbBound === 'true') return;
        controls.dataset.dbBound = 'true';

        const cards = Array.from(grid.querySelectorAll('[data-db-filter-card]'));
        const categorySelect = controls.querySelector('[data-db-filter-category]');
        const sizeSelect = controls.querySelector('[data-db-filter-size]');
        const colorSelect = controls.querySelector('[data-db-filter-color]');
        const availableInput = controls.querySelector('[data-db-filter-available]');
        const sortSelect = controls.querySelector('[data-db-sort]');
        const clearButton = controls.querySelector('[data-db-filter-clear]');
        const activeCount = controls.querySelector('[data-db-active-count]');
        const resultCount = controls.querySelector('[data-db-result-number]');
        const resultLabel = controls.querySelector('[data-db-result-label]');
        const emptyMessage = root.querySelector('[data-db-filter-empty]');
        const singularLabel = controls.querySelector('[data-db-result-count]').dataset.singular;
        const pluralLabel = controls.querySelector('[data-db-result-count]').dataset.plural;
        const normalize = (value) => (value || '').trim().toLowerCase();
        const humanize = (value) => value.replace(/[-_]+/g, ' ').replace(/\b[a-z]/g, (letter) => letter.toUpperCase());

        const fillOptions = (select, values) => {
          const placeholder = select.querySelector('option[value=""]');
          select.replaceChildren(placeholder.cloneNode(true));
          Array.from(values).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })).forEach((value) => {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = humanize(value);
            select.append(option);
          });
        };

        const splitValues = (value) => (value || '').split('|').map(normalize).filter(Boolean);
        const categories = new Set();
        const sizes = new Set();
        const colors = new Set();
        cards.forEach((card) => {
          if (card.dataset.dbCategory) categories.add(normalize(card.dataset.dbCategory));
          splitValues(card.dataset.dbSizes).forEach((value) => sizes.add(value));
          splitValues(card.dataset.dbColors).forEach((value) => colors.add(value));
        });
        fillOptions(categorySelect, categories);
        fillOptions(sizeSelect, sizes);
        fillOptions(colorSelect, colors);

        const applyFilters = () => {
          const category = normalize(categorySelect.value);
          const size = normalize(sizeSelect.value);
          const color = normalize(colorSelect.value);
          const inStockOnly = availableInput.checked;
          const selectedFilterCount = [category, size, color].filter(Boolean).length + (inStockOnly ? 1 : 0);
          const visibleCards = [];

          cards.forEach((card) => {
            const matchesCategory = !category || normalize(card.dataset.dbCategory) === category;
            const matchesSize = !size || splitValues(card.dataset.dbSizes).includes(size);
            const matchesColor = !color || splitValues(card.dataset.dbColors).includes(color);
            const matchesAvailability = !inStockOnly || card.dataset.dbAvailable === 'true';
            const isVisible = matchesCategory && matchesSize && matchesColor && matchesAvailability;
            card.hidden = !isVisible;
            if (isVisible) visibleCards.push(card);
          });

          if (sortSelect.value === 'price-descending') {
            visibleCards.sort((a, b) => Number(b.dataset.dbPrice) - Number(a.dataset.dbPrice));
          } else if (sortSelect.value === 'price-ascending') {
            visibleCards.sort((a, b) => Number(a.dataset.dbPrice) - Number(b.dataset.dbPrice));
          } else {
            visibleCards.sort((a, b) => Number(a.dataset.dbOrder) - Number(b.dataset.dbOrder));
          }
          visibleCards.forEach((card) => grid.append(card));

          resultCount.textContent = String(visibleCards.length);
          resultLabel.textContent = visibleCards.length === 1 ? singularLabel : pluralLabel;
          emptyMessage.hidden = visibleCards.length > 0;
          activeCount.textContent = selectedFilterCount ? `(${selectedFilterCount})` : '';
          activeCount.hidden = selectedFilterCount === 0;
        };

        [categorySelect, sizeSelect, colorSelect, availableInput, sortSelect].forEach((control) => {
          control.addEventListener('change', applyFilters);
        });
        clearButton.addEventListener('click', () => {
          categorySelect.value = '';
          sizeSelect.value = '';
          colorSelect.value = '';
          availableInput.checked = false;
          sortSelect.value = 'featured';
          applyFilters();
        });
        applyFilters();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeDibbsCollections, { once: true });
    } else {
      initializeDibbsCollections();
    }
    document.addEventListener('shopify:section:load', initializeDibbsCollections);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
